var cov_2d8pykaiwj = function () {
  var path = "/Users/spana/SHEIN/shineout/src/CardGroup/index.ts",
      hash = "33d82a3a4788e43bbfbfc62c8b8d2ce278597aa7",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/CardGroup/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 21
        },
        end: {
          line: 6,
          column: 30
        }
      },
      "1": {
        start: {
          line: 8,
          column: 0
        },
        end: {
          line: 8,
          column: 29
        }
      },
      "2": {
        start: {
          line: 10,
          column: 0
        },
        end: {
          line: 10,
          column: 45
        }
      },
      "3": {
        start: {
          line: 11,
          column: 0
        },
        end: {
          line: 11,
          column: 41
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import CardGroup from './CardGroup';
import Item from './Item';
import { consumer } from './context';
var Exports = (cov_2d8pykaiwj.s[0]++, CardGroup);
cov_2d8pykaiwj.s[1]++;
Exports.Item = consumer(Item);
cov_2d8pykaiwj.s[2]++;
Exports.displayName = 'ShineoutCardGroupItem';
cov_2d8pykaiwj.s[3]++;
Exports.displayName = 'ShineoutCardGroup';
export default Exports;